const CONTACT_SHARE_PREVIEW = 'Контакты переданы по взаимному согласию';

export const normalizeChatMessageText = (raw: string | null | undefined): string => {
  if (!raw?.trim()) {
    return 'Нет сообщений';
  }

  try {
    const parsed = JSON.parse(raw) as { kind?: string; text?: string };
    if (parsed?.kind === 'contact_share') {
      return parsed.text?.trim() || CONTACT_SHARE_PREVIEW;
    }
  } catch {
    // обычный текст
  }

  return raw;
};

export const formatChatMessagePreview = (
  raw: string | null | undefined,
  senderUserId: number | null | undefined,
  currentUserId: number,
  options?: { maxOwn?: number; maxOther?: number },
): string => {
  const text = normalizeChatMessageText(raw);
  const maxOwn = options?.maxOwn ?? 24;
  const maxOther = options?.maxOther ?? 32;

  if (senderUserId === currentUserId) {
    const trimmed = text.length > maxOwn ? `${text.slice(0, maxOwn)}...` : text;
    return `Вы: ${trimmed}`;
  }

  return text.length > maxOther ? `${text.slice(0, maxOther)}...` : text;
};
